import React from 'react';
import { useDispatch } from 'react-redux';
import { getResourceTo } from 'react/utils/utils';
import { actionCreators } from 'react/api/actions/eventHttpActionLogs';

function EventLogGridHeader({ selectedGrid, toggleGrid }) {
  const dispatch = useDispatch();

  return (
    <div className="gridHeaderContainer">
      <div className="leftContainer">
        <div className="eventLogRadioOptionsContainer">
          <span id="label-filterBy">{getResourceTo('eventLog.header.filterByText')}</span>
          <div id="radio-list">
            <div>
              <input
                id="eventLog"
                type="radio"
                name="eventGridSelector"
                checked={selectedGrid === 'EventLog'}
                onChange={() => {
                  toggleGrid('EventLog');
                  dispatch(actionCreators.clearEventHttpActionLogs());
                }}
              />
              <label htmlFor="eventLog">{getResourceTo('eventLog.header.eventLogsButton')}</label>
            </div>
            <div>
              <input
                id="eventActionsHttpRequests"
                type="radio"
                name="eventGridSelector"
                checked={selectedGrid === 'EventLogHttpAction'}
                onChange={() => toggleGrid('EventLogHttpAction')}
              />
              <label htmlFor="eventActionsHttpRequests">
                {getResourceTo('eventLog.header.eventHTTPActionsButton')}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventLogGridHeader;
